import { Component } from "react";
import PropTypes from 'prop-types';

class Review extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: this.props.email,
      target: '',
      category: '',
      subject:''
    };
  }

  componentWillMount() {
    const { steps } = this.props;
    let { target, category, email, subject } = steps;
    email = this.props.email;

    this.setState({ target, category, email, subject });
  }

  componentDidMount(){
  }

  render() {
    const { name, target, category, email, subject } = this.state;
    return (
      <div>
        <p>
          Depuis votre adresse <b>{email}</b>.
        </p>
            
        <p>
          Vous nous invitez à prier pour <b>{target.value}</b>
        </p>
         
        <p>
          Dans la catégorie:<br/> 
          <b>{category.message}</b>
        </p>
         
        <p>
          Le sujet est:<br/> 
          <b>{subject.message}</b>
        </p>

      </div>
    );
  }
}

Review.propTypes = {
  steps: PropTypes.object,
};

Review.defaultProps = {
  steps: undefined,
};


export default Review;